import { IState } from '../../store';

export const selectIsPartnerRewardsRegistrationStatusAvailable = (state: IState) =>
  state.offerData.newbuildingBroker?.partnerRewardsRegistrationStatus === 'available';
